<template>
    <div>
        <p class="font-medium text-sm">
            <slot></slot>
        </p>
        <div class="space-x-3">
            <label :for="`${name}-radio-yes`">
                <input
                    type="radio"
                    :id="`${name}-radio-yes`"
                    :name="name"
                    value="1"
                    v-model="radio"
                >
                Sí
            </label>
            <label :for="`${name}-radio-no`">
                <input
                    type="radio"
                    :id="`${name}-radio-no`"
                    :name="name"
                    value="0"
                    v-model="radio"
                >
                No
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: ["name", "value"],
    computed: {
        radio: {
            get: function () {
                return this.value;
            },
            set: function (value) {
                this.$emit("change", value);
            },
        },
    },
};
</script>

<style>
input[type="radio"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    border-radius: 50%;
    width: 16px;
    height: 16px;

    border: 2px solid #e3dcd3;
    /* transition: 0.2s all linear; */
    margin-right: 5px;

    background-color: #fff;

    position: relative;
    top: 4px;
}

input[type="radio"]:checked::after {
    /* border: 2px solid #e3dcd3;
    background-color: #00aad2; */
    content: "";
    display: inline-block;
    border-radius: 50%;
    background-color: #00aad2;
    width: 70%;
    height: 70%;
    position: absolute;
    top: 2px;
    left: 2px;
}
</style>